import React, { useRef, useState } from 'react';
import { useMediaQuery, useTheme, Box } from '@mui/material';
import DataGridComponent from 'components/DataGridComponent';
import ScrollToTop from 'components/ScrollToTop';
import CrewAssessmentList from './CrewAssessmentList';


const CrewAssessment = ({
    rows,
    columns,
    loading,
    setRowSelectionModel,
    rowSelectionModel,
    canEdit,
    canDelete,
    onEdit,
    onDelete,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const scrollRef = useRef(null);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({ _id: false });

    if (isMobile) {
        return (
            <Box 
                ref={scrollRef} 
                height="100%" 
                sx={{ overflowY: 'auto' }}
            >
                <CrewAssessmentList
                    rows={rows || []}
                    canEdit={canEdit}
                    canDelete={canDelete}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />

                <ScrollToTop scrollRef={scrollRef} />
            </Box>
        );
    }

    return (
        <Box height="100%">
            <DataGridComponent
                rows={rows || []}
                columns={columns}
                columnVisibilityModel={columnVisibilityModel}
                setColumnVisibilityModel={setColumnVisibilityModel}
                loading={loading}
                props={{
                    rowSelectionModel,
                    onRowSelectionModelChange: (newModel) => setRowSelectionModel(newModel),
                }}
            />
        </Box>
    );
};

export default CrewAssessment;
